import { render } from "./HorizontalSplitter.vue?vue&type=template&id=92160282&scoped=true"
import script from "./HorizontalSplitter.vue?vue&type=script&lang=js"
export * from "./HorizontalSplitter.vue?vue&type=script&lang=js"

import "./HorizontalSplitter.vue?vue&type=style&index=0&id=92160282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92160282"]])

export default __exports__